export default {
  errorPopup(str, bvToast) {
    if (bvToast && bvToast.toast) {
      bvToast.toast(`${str}`, {
        title: "Error",
        variant: "danger"
      })
    }
    else alert(str)
  },
  loopFunc(obj, bvToast, cb) {
    let objectData = obj || {}
    let errKeys = ['error', 'msg', 'errorMessage', 'message']

    for (let key in objectData) {
      if (objectData[key] && typeof objectData[key] == 'string' && errKeys.includes(key)) {
        this.errorPopup(objectData[key], bvToast)
      }
      else {
        cb && cb(objectData[key])
      }
    }
  },
  errorHandler (err, bvToast) {
    let error = err || {}
    let errorResponseKeys = ['response', 'data', 'message', 'msg', 'errorMessage', 'errMsg']

    if (typeof error == 'object') {
      if (Object.entries(error).length) {
        for (let key in error) {
          if (typeof error[key] == 'string' && errorResponseKeys.includes(key)) {
            this.errorPopup(error[key], bvToast)
          }
          else if (
            typeof error[key] == 'object'
            && Object.entries(error[key]).length
            && errorResponseKeys.includes(key)
          ) {
            this.loopFunc(error[key], bvToast, obj => {
              this.loopFunc(obj, bvToast, obj1 => {
                this.loopFunc(obj1, bvToast, obj2 => {
                  this.loopFunc(obj2, bvToast, obj3 => {
                    this.loopFunc(obj3, bvToast)
                  })
                })
              })
            })
          }
          else if (
            errorResponseKeys.includes(key)
            && typeof error[key] == 'object'
            && !Object.entries(error[key]).length
          ) {
            this.errorPopup("Internal Server Error", bvToast)
          }
        }
      }
    }
    else if (typeof error == 'string') this.errorPopup(error, bvToast)
  }
}
